import React, { useState, useEffect } from "react";
import { fetch, fetchLocalAgent } from "../../actions";
import { connect } from "react-redux";
import { InputPadrao, LabelPadrao, LoadingContainerPadrao, ModalPadrao, TextAreaPadrao } from "../../components/Base";
import { Radio, Tag } from 'antd';
import Pagamento, { ValoresExtrasPagamento } from "../Pagamento/Pagamento";
import EntregaEnderecoSelect from "./EntregaEnderecoSelect";
import formatarData from "../../Utils/formatarData";
import { BtnCancelar, BtnGravar, BtnPadrao, BtnSair } from "../../components/Buttons";
import useTotais from "../../components/Hooks/useTotais";
import { formatarPagamentos, returnStatus } from "../../Utils/utils";
import toLocale from "../../Utils/ToLocaleString";
import roundCustom from "../../Utils/RoundCustom";
import VendaDevolucaoModal from "../Venda/VendaDevolucaoModal";
import useSavePagamentos from "../../components/Hooks/useSavePagamentos";
import ErroModal from "../../components/ErroModal";
import SelectPesq from "../../components/Selects/SelectPesq";
import ModalTransportadora from "../Balcao/ModalTransportadora";
import { imprimirRetorno } from "../../Utils/impressaoUtils";
import DanfeViewer from "../Venda/NotaFiscal/DanfeViewer";
import ImpressaoVenda from "../Impressao/ImpressaoVenda";
import ImpressaoVendaOpcional from "../Impressao/ImpressaoVendaOpcional";

function ModalFinalizarEntrega({ visible, entrega, onSave, onCancel, ...props }) {
    const [pg, setPg] = useState([]);
    const [detalhe, setDetalhe] = useState(null);
    const [modalDevVisivel, setModalDevVisivel] = useState(false);
    const [modalTranspVisivel, setModalTranspVisivel] = useState(false);
    const totais = useTotais(detalhe?.itensVenda || [], pg, entrega);
    const [erroFinalizacao, setErroFinalizacao] = useState();
    const [dadosDanfe, setDadosDanfe] = useState(null);
    const [idVendaImpressao, setIdVendaImpressao] = useState(null);
    const [dadosImpressaoOpcional, setDadosImpressaoOpcional] = useState(null);
    const [salvar, salvando, processandoPagamentos, abortar, abortando] = useSavePagamentos("/prevenda/entrega/save", { ...detalhe, pagamentos: formatarPagamentos(pg, totais.troco).filter(x => !!x.modalidadeId), valorTotal: totais.liquido, ...totais },
        v => {

            if (v.isDanfe)
                setDadosDanfe(v);
            else if (!!v.vendaId)
                setIdVendaImpressao(v.vendaId);
            else if (!!v.vendaImpressaoNaoObrigatoriaId)
                setDadosImpressaoOpcional(v);
            else
                imprimirRetorno(props.fetchLocalAgent, v);

            onSave();

        }, props.fetch, erros => setErroFinalizacao({ title: "Erro ao processar o pagamento", erros }), erro => setErroFinalizacao({ title: "Erro ao processar a venda", erros: [erro] }));

    const parametros = props?.parametros || {};

    useEffect(() => {
        if (visible) {
            let modeloNF;
            let tipoEmissaoNota = parametros['TipoEmissaoNotaVenda'];
            if (tipoEmissaoNota == "Cupom")
                modeloNF = "nfce";
            else if (tipoEmissaoNota == "Danfe")
                modeloNF = "nfe";

            const itensVenda = [...(entrega?.produtos || []), ...(entrega?.servicos || []).map(x => ({ ...x, isServico: true }))];
            setDetalhe({ ...entrega, modeloNF, itensVenda });

            let recebido = totais.calcularLiquido(itensVenda, entrega);

            const pagamentos = entrega?.pagamentos;

            const pgtos = (pagamentos || []).filter(x => x.modalidadeId > 0);
            const valorPgtos = roundCustom(pgtos.reduce((a, b) => a + b.recebido, 0));

            if (valorPgtos < recebido)
                pgtos.push({ modalidadeId: null, recebido: roundCustom(recebido - valorPgtos) });

            setPg(pgtos);
        }

    }, [visible]);

    const showPgtos = detalhe?.isPagamentoPendente || (detalhe?.isReentrega ? detalhe?.status == "ROT" && !detalhe?.isPagamentoAntecipado : !detalhe?.isPagamentoAntecipado);

    if (!detalhe)
        return <></>;

    return <>
        <ModalPadrao closable={false} title={detalhe?.status === "ROT" ? "Finalizar entrega" : "Enviar entrega"} visible={visible} width={1000} footer={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    {(showPgtos && detalhe?.status === "ROT") && <BtnPadrao style={{ marginRight: 10 }} disabled={salvando} onClick={() => setModalDevVisivel(true)}>Devolver Itens</BtnPadrao>}
                    {(detalhe?.status === "LIB" && !detalhe?.isReentrega) && <BtnPadrao onClick={() => setModalTranspVisivel(true)}>Dados transporte</BtnPadrao>}
                </div>
                <div>
                    <BtnGravar disabled={!(detalhe?.isPagamentoAntecipado && detalhe?.status != "PEN") && pg.find(x => x.modalidadeId == null || x.modalidadeId <= 0)} onClick={salvar} loading={salvando} />
                    {processandoPagamentos ? <BtnCancelar loading={abortando} onClick={() => abortar()} showConfirm /> : <BtnSair disabled={salvando} onClick={onCancel} />}
                </div>
            </div>}>

            <LoadingContainerPadrao style={{ minHeight: 350 }} loading={salvando} loadingMsg={processandoPagamentos ? 'Processando pagamentos' : null}>
                <div style={{ display: "flex" }}>
                    <div style={{ width: "60%" }}>
                        <LabelPadrao noMargin>Cliente</LabelPadrao>
                        <InputPadrao disabled value={detalhe?.clienteId[0].label} />
                    </div>
                    <div style={{ margin: "0 10px", width: "20%" }}>
                        <LabelPadrao noMargin>Número</LabelPadrao>
                        <InputPadrao disabled value={detalhe?.numero} />
                    </div>
                    <div style={{ width: "20%" }}>
                        <LabelPadrao noMargin>Data pedido</LabelPadrao>
                        <InputPadrao disabled value={formatarData(detalhe?.data).DATAHORASEGUNDOS} />
                    </div>
                </div>

                <div style={{ display: "flex" }}>
                    <div style={{ width: "80%" }}>
                        <LabelPadrao>Endereço</LabelPadrao>
                        <EntregaEnderecoSelect value={detalhe.pessoaEnderecosId} onChange={v => setDetalhe({ ...detalhe, pessoaEnderecosId: v.id, endereco: v })} clienteId={(detalhe?.clienteId || [])[0].id} disableEdit={detalhe?.status === "ROT"} />
                    </div>

                    <div style={{ width: "20%", marginLeft: 10 }}>
                        <LabelPadrao>Status</LabelPadrao>
                        <Tag style={{ padding: 5, width: "100%", textAlign: "center", fontSize: 13 }} color={returnStatus(detalhe?.status).color}>{returnStatus(detalhe?.status).title}</Tag>
                    </div>
                </div>

                {(detalhe?.status == "LIB" || detalhe?.status == "ROT") && <>
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "50%", marginRight: 10 }}>
                            <SelectPesq placeholder="Informe o entregador" title="Entregador" modelo="entregador" onChange={v => setDetalhe({ ...detalhe, entregadorId: v })} value={detalhe.entregadorId || undefined} tabIndex={200} disabled={detalhe?.status != "LIB"} />
                        </div>
                        <div style={{ width: "50%" }}>
                            <SelectPesq placeholder="Informe o veículo" title="Veículo" modelo="veiculo" onChange={v => setDetalhe({ ...detalhe, veiculoId: v, placaVeiculo: v?.length ? v[0].placa : null, ufVeiculo: v?.length ? v[0].uf : null, antt: null })} value={detalhe.veiculoId || undefined} tabIndex={201} disabled={detalhe?.status != "LIB"} />
                        </div>
                    </div>

                    <LabelPadrao>Observação</LabelPadrao>
                    <TextAreaPadrao placeholder="Informe a observação" value={detalhe.obs} onChange={v => setDetalhe({ ...detalhe, obs: v.target.value })} tabIndex={202} disabled={detalhe?.status != "LIB"} />
                </>}

                {showPgtos && <div style={{ marginTop: 25 }}>

                    {((detalhe?.status === "LIB" || detalhe?.status === "PEN") && props.hasCertificadoDigital) && <div style={{ textAlign: "center", marginBottom: 25 }}>
                        <LabelPadrao noMargin>Forma de emissão</LabelPadrao>
                        <Radio.Group value={detalhe.modeloNF} onChange={v => setDetalhe({ ...detalhe, modeloNF: v.target.value })}>
                            <Radio value="nfce">Cupom</Radio>
                            <Radio style={{ margin: 0 }} value="nfe">Danfe</Radio>
                        </Radio.Group>
                    </div>}
                    <Pagamento
                        totais={totais}
                        pg={pg}
                        setPg={setPg}
                        clienteId={detalhe?.clienteId[0].id || detalhe?.clienteId[0].key}
                        tipo="venda"
                        hideOperacoes={detalhe?.status == "LIB" ? ["cartao"] : false}
                        isEntrega={!detalhe.isPagamentoPendente}
                        tabIndex={203}
                        extra={<ValoresExtrasPagamento valoresExtras={entrega} disabled isEntrega />}
                    />
                    {!!totais.devolucao && <InfoDevolucaoPag totais={totais} />}

                </ div>}

            </LoadingContainerPadrao>

            <VendaDevolucaoModal visible={modalDevVisivel} produtos={detalhe?.produtos} pagamentos={detalhe?.pagamentosDev} pagamentosOriginais={detalhe?.pagamentos} onCancel={() => setModalDevVisivel(false)} onOk={(produtos, pgtos, totaisDev) => {
                setDetalhe({ ...detalhe, produtos, pagamentosDev: pgtos, valorTotalDev: totaisDev.liquido, descontoDev: totaisDev.desconto, acrescimoDev: totaisDev.acrescimo, valorFreteDev: totaisDev.valorFrete, trocoDev: totaisDev.troco });
                setModalDevVisivel(false);
            }} />

            <ErroModal title="Erro ao processar o pagamento" visible={!!erroFinalizacao} onCancel={() => setErroFinalizacao(null)} >
                {erroFinalizacao?.erros?.map(x => <p key={x?.toString()} style={{ marginTop: 20, textAlign: "center" }}>{x?.toString()}</p>)}
            </ErroModal>

            <ModalTransportadora visible={modalTranspVisivel} dados={{ ...detalhe?.dadosFreteNF, valorFreteNf: detalhe.valorFrete }} onCancel={() => setModalTranspVisivel(false)} onOk={v => { setDetalhe({ ...detalhe, dadosFreteNF: v }); setModalTranspVisivel(false); }} isEntrega />
        </ModalPadrao>

        <DanfeViewer visible={!!dadosDanfe} empresaPk={dadosDanfe?.empresaPk} chave={dadosDanfe?.chaveNfe} onCancel={() => setDadosDanfe(null)} />
        <ImpressaoVenda id={idVendaImpressao} onCancel={() => setIdVendaImpressao(null)} />
        <ImpressaoVendaOpcional id={dadosImpressaoOpcional?.vendaImpressaoNaoObrigatoriaId} vias={dadosImpressaoOpcional?.vias} onOk={() => setDadosImpressaoOpcional(null)} onCancel={() => setDadosImpressaoOpcional(null)} />
    </>;
}

function InfoDevolucaoPag({ totais }) {
    return <>
        <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)", marginTop: 10 }}>
            <LabelPadrao noMargin>Valor devolvido:</LabelPadrao>
            <span style={{ fontSize: "1.25em", color: "#d1d1d1" }}>{toLocale(totais.devolucao)}</span>
        </div>
        <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
            <LabelPadrao noMargin>Valor final:</LabelPadrao>
            <span style={{ fontSize: "1.25em", color: "#d1d1d1" }}>{toLocale(roundCustom(totais.liquido - totais.devolucao))}</span>
        </div>
    </>;
}

const mapStateToProps = state => ({ hasCertificadoDigital: state.dados.hasCertificadoDigital, parametros: state.dados.parametros });

export default connect(mapStateToProps, { fetch, fetchLocalAgent })(ModalFinalizarEntrega);